module.exports = __webpack_public_path__ + "static/media/microelastic_words_and_logo_bold.ea8a16e9.png";